import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { InvVoucherPricing } from "../../models/inv-voucher-pricing.model";

@Component({
  selector: "ngx-inv-voucher-pricing-form",
  templateUrl: "./inv-voucher-pricing-form.component.html",
  styleUrls: ["./inv-voucher-pricing-form.component.scss"],
})
export class InvVoucherPricingFormComponent extends BaseFormComponent<InvVoucherPricing> {
  BranchIds: number[] = [];
  WarehouseIds: number[] = [];
  voucherColumns: form_control[] = [];
  dataList: any[] = [];
  erroremessage: string;
  isLoadingLastDate: boolean = false;
  constructor(
    private _tabsservice: TabularService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private missetup: MisSetupService
  ) {
    super(selectorService, cd);
    this.missetup.getall();
  }
  async ngOnInit() {
    this.apiName = "InvVoucherPricing";
    this.label = "قیمت گذاری اسناد";
    super.ngOnInit();
    this.set_Columns();
    this.setDate();
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    this.orignalColumns.forEach((x) => {
      if (x.name === "WarehouseId" || x.name === "BranchId") x.required = false;
    });

    this.columns.forEach((x) => ((x.isFloat = null), (x.userClass = null)));
    this.cd.markForCheck();
  }
  onChanged($event) {
    if (
      (this.formGroup.controls["BranchIds"] && this.formGroup.controls["BranchIds"].value.length > 0) ||
      (this.formGroup.controls["WarehouseIds"] && this.formGroup.controls["WarehouseIds"].value.length > 0)
    ) {
      if ($event && $event?.name !== "PrevUpdateDate") this.setDate();
      this.isValid();
    }
  }
  getFilter(): GridFilter[] {
    let filter: GridFilter[] = [];
    if (!this.model.FiscalYearId) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    filter.push({ Type: "F", Filed: "FiscalYearId", Value: this.model.FiscalYearId, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "BranchIds", Value: this.formGroup.controls["BranchIds"].value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({
      Type: "F",
      Filed: "WarehouseIds",
      Value: this.formGroup.controls["WarehouseIds"].value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    filter.push({
      Type: "F",
      Filed: "PrevUpdateDate",
      Value: new Date(this.formGroup.controls["PrevUpdateDate"].value),
      Logic: "and",
      Operator: "gte",
      Skip: 0,
      Take: 0,
    });
    filter.push({
      Type: "F",
      Filed: "LastUpdateDate",
      Value: new Date(this.formGroup.controls["LastUpdateDate"].value),
      Logic: "and",
      Operator: "lte",
      Skip: 0,
      Take: 0,
    });
    return filter;
  }
  setDate() {
    if (this.isLoadingLastDate) return;
    this.isLoadingLastDate = true;
    let filter: GridFilter[] = [];
    if (!this.model.FiscalYearId) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    filter.push({ Type: "F", Filed: "FiscalYearId", Value: this.model.FiscalYearId, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    if (this.formGroup?.controls["BranchIds"]?.value)
      filter.push({
        Type: "F",
        Filed: "BranchIds",
        Value: this.formGroup.controls["BranchIds"].value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    if (this.formGroup?.controls["WarehouseIds"]?.value)
      filter.push({
        Type: "F",
        Filed: "WarehouseIds",
        Value: this.formGroup.controls["WarehouseIds"].value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });

    this.httpCommonService
      .create(this.apiName + "/GetLastDate/", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Date) => {
          this.isLoadingLastDate = false;
          this.model.PrevUpdateDate = data;
          this.setValue("PrevUpdateDate", this.model.PrevUpdateDate);
          this.fillData();
        },
        (error) => {
          this.isLoadingLastDate = false;
          this.getFailedHelper(error);
        }
      );
  }
  fillData() {
    this.httpCommonService
      .create(this.apiName + "/GetInvVoucherList", this.getFilter())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.dataList = (data as []).sort((a, b) => new Date(a["VoucherDate"]).getTime() - new Date(b["VoucherDate"]).getTime());
          if (new Date(this.dataList[0].VoucherDate).getTime() < new Date(this.formGroup.get("PrevUpdateDate").value).getTime())
            this.setValue("PrevUpdateDate", this.dataList[0].VoucherDate);
          this.isValid();
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setdefault() {
    this.model.BranchId = this.accountService.authService.currentBranchId;
    this.model.LastUpdateDate = new Date();
    if (this.accountService.authService.currentFiscalYear) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
        }
      });
  }
  isValid() {
    this.erroremessage = undefined;
    let flag: boolean = true;
    if (!this.formGroup.controls["BranchIds"] || this.formGroup.controls["BranchIds"].value.length <= 0) {
      this.erroremessage = "شعبه انتخاب نشده است.";
      flag = false;
    }
    if (flag && (!this.formGroup.controls["WarehouseIds"] || this.formGroup.controls["WarehouseIds"].value.length <= 0)) {
      this.erroremessage = "انبار انتخاب نشده است.";
      flag = false;
    }
    if (flag && (!this.dataList || this.dataList.length <= 0)) {
      this.erroremessage = "هیچ حواله ای جهت قیمت گذاری وجود ندارد.";
      flag = false;
    }
    if (
      flag &&
      new Date(this.formGroup.controls["LastUpdateDate"].value).setHours(0, 0, 0, 0) <
        new Date(this.formGroup.controls["PrevUpdateDate"].value).setHours(0, 0, 0, 0)
    ) {
      this.erroremessage = "تا تاریخ نمی تواند کوچکتر از شروع تاریخ قیمت گذاری باشد.";
      flag = false;
    }
    return flag;
  }

  addControl() {
    if (this.formGroup) {
      this.setValue("BranchIds", this.BranchIds);
      this.setValue("WarehouseIds", this.WarehouseIds);
    }
  }
  set_Columns() {
    this.voucherColumns = [];
    this.voucherColumns.push(<form_control>{
      label: "نوع سند",
      controlType: FormControlTypes.textbox,
      modelName: "WarehouseTitle",
      disabled: false,
      name: "WarehouseTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 40,
    });
    this.voucherColumns.push(<form_control>{
      label: "شماره سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherNo",
      disabled: false,
      name: "VoucherNo",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 10,
    });
    this.voucherColumns.push(<form_control>{
      label: "شماره پیگیر",
      controlType: FormControlTypes.textbox,
      modelName: "SlaveNo",
      disabled: false,
      name: "SlaveNo",
      order: 2,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 10,
    });
    this.voucherColumns.push(<form_control>{
      label: "تاریخ سند",
      controlType: FormControlTypes.textbox,
      modelName: "ShamsiVoucherDate",
      disabled: false,
      name: "ShamsiVoucherDate",
      order: 3,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 20,
    });
    this.orignalColumns = this.columns;
  }
  public async save() {
    if (!this.isSaving) {
      if (this.isValid()) {
        this.beforupdate();
        this.sts.showToast("info", "", "در حال قیمت گذاری...");
        this.isSaving = true;
        this.isSaved = false;
        this.httpCommonService
          .create(this.apiName + "/VoucherPricing", this.getFilter())
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (row) => {
              this.saveSuccessHelper(row);
              this._tabsservice.tabItemonRefreshData.next(this.apiName);
            },
            (error) => this.saveFailedHelper(error)
          );
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } else {
      this.selectorService.submitted$.next(this.submitted);
    }
  }
}
